import { Transaction } from "@near-wallet-selector/core";

import { config } from "@/services/config";
import { NearRPCProviderService } from "@/services/rpc/near";

import { convertGas } from "./helpers";

class AirdropContract {
  readonly contractId: string;

  private provider: NearRPCProviderService;

  public constructor({ provider, contractId }: { provider: NearRPCProviderService; contractId: string }) {
    this.contractId = contractId;
    this.provider = provider;
  }

  public async getAirdropsCount() {
    return this.provider.viewFunction("get_airdrops_count", this.contractId, {});
  }

  public async get_users_count(airdropId: number) {
    return this.provider.viewFunction("get_users_count", this.contractId, { airdrop_id: airdropId });
  }

  public async get_available_drops_for_nft(nftId: string) {
    return this.provider.viewFunction("get_available_drops_for_nft", this.contractId, { nft_id: nftId });
  }

  public async get_available_drops_for_user(accountId: string) {
    return this.provider.viewFunction("get_available_drops_for_user", this.contractId, { account_id: accountId });
  }

  public async is_nft_participated(airdropId: number, nftId: string) {
    return this.provider.viewFunction("is_nft_participated", this.contractId, { airdrop_id: airdropId, nft_id: nftId });
  }

  public async get_start_date(airdropId: number) {
    return this.provider.viewFunction("get_start_date", this.contractId, { airdrop_id: airdropId });
  }

  public async get_airdrops(accountId: string, nftIds: Array<string>) {
    return this.provider.viewFunction("get_airdrops", this.contractId, { user_id: accountId, nft_ids: nftIds });
  }

  public async get_airdrop(airdropId: number) {
    return this.provider.viewFunction("get_airdrop", this.contractId, { airdrop_id: airdropId });
  }

  public async get_user_score(accountId: string) {
    return this.provider.viewFunction("get_user", config.near.score, { account_id: accountId });
  }

  public async get_available_trust_score() {
    return this.provider.viewFunction("get_available_trust_score", this.contractId, {});
  }

  public async get_user_number_of_claims(airdropId: number, accountId?: string | null): Promise<number> {
    if (!accountId) return 0;
    try {
      const count = await this.provider.viewFunction("get_user_number_of_claims", this.contractId, {
        account_id: accountId,
        airdrop_id: airdropId,
      });
      return count ? count : 0;
    } catch (e) {
      return 0;
    }
  }

  public createClaimDropsByIdTransaction({
    signerId,
    receiverId,
    airdropId,
    nftIds,
    signature,
    tokenBalance,
  }: {
    signerId: string;
    tokenBalance: string;
    receiverId: string;
    airdropId: number;
    nftIds: Array<string>;
    signature: Array<number>;
  }): Transaction {
    return {
      signerId,
      receiverId,
      actions: [
        {
          type: "FunctionCall",
          params: {
            methodName: "claim_drops_by_airdrop_id",
            args: {
              airdrop_id: airdropId,
              nft_ids: nftIds,
              signature,
              token_balance: tokenBalance,
            },
            gas: convertGas("280"),
            deposit: "0",
          },
        },
      ],
    };
  }
}

export const NearAirdropContract = new AirdropContract({
  provider: new NearRPCProviderService(),
  contractId: config.near.airdrop,
});
